import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";
import "../App.css"

const formatCurrencyAxis = (value) => {
  if (value === 0) return "₹0";
  if (value >= 10000000) return `₹${(value / 10000000).toFixed(0)} crore`;
  return `₹${Math.round(value / 100000)} lakh`;
};

const formatCurrency = (value) => `₹${Number(value || 0).toLocaleString("en-IN")}`;

function SalesTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;

  const adsSales = payload.find((entry) => entry.dataKey === "adsSales");
  const billedAmount = payload.find((entry) => entry.dataKey === "billed_amount");

  return (
    <div className="sales-tooltip">
      <div className="sales-tooltip__row">
        <span className="sales-tooltip__label"><i className="sales-tooltip__dot sales-tooltip__dot--sales" />Ads Sales</span>
        <strong>{formatCurrency(adsSales?.value)}</strong>
      </div>
      <div className="sales-tooltip__row">
        <span className="sales-tooltip__label"><i className="sales-tooltip__dot sales-tooltip__dot--billed" />Billed Amount</span>
        <strong>{formatCurrency(billedAmount?.value)}</strong>
      </div>
    </div>
  );
}

// const data = [
//   { month: "Jan", sales: 2800000, spend: 2400000, roi: 5.2 },
//   { month: "Feb", sales: 3100000, spend: 2600000, roi: 5.8 },
//   { month: "Mar", sales: 2900000, spend: 2500000, roi: 6.1 },
//   { month: "Apr", sales: 3500000, spend: 2800000, roi: 6.9 },
//   { month: "May", sales: 3300000, spend: 2700000, roi: 7.4 },
// ];

export default function AdsPerformance({data}) {
  return (
    <section className="overview-analytics-card overview-analytics-card--ads">
        <div className="overview-analytics-card__header">
          <div>
            <p className="overview-analytics-card__eyebrow">Paid acquisition</p>
            <h3>Sales vs Ads Billed</h3>
          </div>
          <span className="overview-analytics-card__unit">₹ amount</span>
        </div>

        <div className="overview-analytics-card__chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 12, right: 8, left: 8, bottom: 0 }}>
            <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
            <XAxis dataKey="period" axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} />
            <YAxis width={74} axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} tickFormatter={formatCurrencyAxis} />
            <Tooltip
              content={<SalesTooltip />}
            />
            <Legend wrapperStyle={{ paddingTop: "10px", fontSize: "12px" }} />
            <Bar
              dataKey="adsSales"
              fill="#3b82f6"
              radius={[6, 6, 0, 0]}
            />
            <Bar
              dataKey="billed_amount"
              fill="#f97316"
              radius={[6, 6, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
        </div>
    </section>
  );
}
